import { IAllShortageInvestigation } from "../models/shortage";
import {
  CHECK_BOX_MSG,
  ConditionalField,
  CreateDynamicSchema,
  FieldConfig,
  OPTION_MSG,
  REQUIRED_MSG,
  RequiredField,
} from "./formik";

//  AS Investigation form day wise fields Start
const asDay1Fields: FieldConfig[] = [
  RequiredField("showAtDestTerm", OPTION_MSG),
  ConditionalField("dateToDestTerm", "showAtDestTerm", "N", true, "Required field: Please select a date"),
  RequiredField("notInDestTerm", CHECK_BOX_MSG, true, "string", true),
  ConditionalField("notInDestTermSteps", "notInDestTerm", "Y", false),
  RequiredField("day1F18Note"),
];

const asDay2Fields: FieldConfig[] = [
  RequiredField("noMovement", CHECK_BOX_MSG, true, "string", true),
  ConditionalField("dateLastMovement", "noMovement", "Y", true, "Required field: Please select a date"),
  ConditionalField("noMovementSteps", "noMovement", "Y", false),
  RequiredField("suffixBill", CHECK_BOX_MSG, true, "string", true),
  ConditionalField("suffixBillSteps", "suffixBill"),
  RequiredField("bolCheck", CHECK_BOX_MSG, true, "string", true),
  ConditionalField("bolCheckSteps", "bolCheck"),
  RequiredField("drCheck", OPTION_MSG),
  ConditionalField("drCheckSteps", "drCheck"),
  RequiredField("day2F18Note"),
];

const asDay3Fields: FieldConfig[] = [
  RequiredField("pumCheck", CHECK_BOX_MSG, true, "string", true),
  ConditionalField("pickupManifest", "pumCheck"),
  ConditionalField("pumSteps", "pumCheck"),
  RequiredField("shipperLoad", OPTION_MSG),
  ConditionalField("discrepancies", "shipperLoad"),
  RequiredField("checkLinehaulManifests", CHECK_BOX_MSG, true, "string", true),
  ConditionalField("linehaulManifests", "checkLinehaulManifests"),
  RequiredField("interviewWorkers", CHECK_BOX_MSG, true, "string", true),
  ConditionalField("workerSteps", "interviewWorkers"),
  RequiredField("consigneePhone"),
  RequiredField("consigneeName"),
  RequiredField("consigneeShort", OPTION_MSG),
  ConditionalField("itemNumbers", "consigneeShort"),
  ConditionalField("orderReceived", "consigneeShort"),
  ConditionalField("freightLabeled", "consigneeShort"),
  RequiredField("shipperPhone"),
  RequiredField("shipperName"),
  RequiredField("shippedDetails"),
  RequiredField("shortShipped"),
  RequiredField("productValue"),
  RequiredField("multShipments"),
  RequiredField("day3F18Note"),
];

const asDay4Fields: FieldConfig[] = [
  RequiredField("check7818", CHECK_BOX_MSG, true, "string", true),

  ConditionalField("details7818", "check7818"),
  RequiredField("manifested", OPTION_MSG),
  ConditionalField("cameraFindings", "manifested"),
  RequiredField("callSameDays", CHECK_BOX_MSG, true, "string", true),

  {
    name: "callSameDaysDataset",
    type: "array",
    when: {
      key: "callSameDays",
      value: "Y",
      required: true,
      message: REQUIRED_MSG,
    },
    schema: [
      {
        name: "deliveryInfo",
        type: "string",
        nullable: true,
        required: true,
        message: REQUIRED_MSG,
      },
      {
        name: "sameDayPro",
        type: "string",
        nullable: true,
        required: true,
        message: REQUIRED_MSG,
      },
    ],
  },

  RequiredField("day4F18Note"),
];

const asDay5Fields: FieldConfig[] = [
  RequiredField("contactTerminals", CHECK_BOX_MSG, true, "string", true),
  {
    name: "freightTerminalLeadInquiries",
    type: "array",
    when: {
      key: "contactTerminals",
      value: "Y",
      required: true,
      message: REQUIRED_MSG,
    },
    schema: [
      {
        name: "terminal",
        type: "string",
        nullable: true,
        required: true,
        message: REQUIRED_MSG,
      },
      {
        name: "manifest",
        type: "string",
        nullable: true,
        required: true,
        message: REQUIRED_MSG,
      },
      {
        name: "discrepancies",
        type: "string",
        nullable: true,
        required: true,
        message: REQUIRED_MSG,
      },
    ],
  },
  RequiredField("day5F18Note"),
];

const asDay10Fields: FieldConfig[] = [
  RequiredField("followUp", CHECK_BOX_MSG, true, "string", true),
  ConditionalField("followUpDetails", "followUp"),
  RequiredField("day10F18Note"),
];

const asDay15Fields: FieldConfig[] = [
  RequiredField("check7818_2", CHECK_BOX_MSG, true, "string", true),
  ConditionalField("details7818_2", "check7818_2"),
  RequiredField("highValue", OPTION_MSG),
  RequiredField("day15F18Note"),
];

const asDay20Fields: FieldConfig[] = [
  RequiredField("finalReCheck", CHECK_BOX_MSG, true, "string", true),
  RequiredField("detailsOfSearch", "", false),
  RequiredField("day20F18Note"),
];

// Exporting the dynamically created schema for all day
export const ASInvestigationSchema = [
  CreateDynamicSchema(asDay1Fields),
  CreateDynamicSchema(asDay2Fields),
  CreateDynamicSchema(asDay3Fields),
  CreateDynamicSchema(asDay4Fields),
  CreateDynamicSchema(asDay5Fields),
  CreateDynamicSchema(asDay10Fields),
  CreateDynamicSchema(asDay15Fields),
  CreateDynamicSchema(asDay20Fields),
];

export const ASInvestigationInitValue: IAllShortageInvestigation = {
  // Day 1
  showAtDestTerm: undefined,
  dateToDestTerm: undefined,
  notInDestTerm: undefined,
  notInDestTermSteps: undefined,
  // Day 2
  noMovement: undefined,
  dateLastMovement: undefined,
  noMovementSteps: undefined,
  suffixBill: undefined,
  suffixBillSteps: undefined,
  bolCheck: undefined,
  bolCheckSteps: undefined,
  drCheck: undefined,
  drCheckSteps: undefined,
  // Day 3
  pumCheck: undefined,
  pickupManifest: undefined,
  pumSteps: undefined,
  shipperLoad: undefined,
  discrepancies: undefined,
  checkLinehaulManifests: undefined,
  linehaulManifests: undefined,
  interviewWorkers: undefined,
  workerSteps: undefined,
  consigneePhone: undefined,
  consigneeName: undefined,
  consigneeShort: undefined,
  itemNumbers: undefined,
  orderReceived: undefined,
  freightLabeled: undefined,
  shipperPhone: undefined,
  shipperName: undefined,
  shippedDetails: undefined,
  shortShipped: undefined,
  productValue: undefined,
  multShipments: undefined,
  // Day 4
  check7818: undefined,
  details7818: undefined,
  manifested: undefined,
  cameraFindings: undefined,
  callSameDays: undefined,
  callSameDaysDataset: [
    {
      sameDayPro: undefined,
      deliveryInfo: undefined,
    },
  ],
  // Day 5
  contactTerminals: undefined,
  freightTerminalLeadInquiries: [
    { terminal: undefined, manifest: undefined, discrepancies: undefined },
  ],
  // Day 10
  followUp: undefined,
  followUpDetails: undefined,
  // Day 15
  check7818_2: undefined,
  details7818_2: undefined,
  highValue: undefined,
  // Day 20
  finalReCheck: undefined,
  detailsOfSearch: undefined,

  day1F18Note: undefined,
  day2F18Note: undefined,
  day3F18Note: undefined,
  day4F18Note: undefined,
  day5F18Note: undefined,
  day10F18Note: undefined,
  day15F18Note: undefined,
  day20F18Note: undefined,
};
// AS Investigation form End
